"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataLayerPush = void 0;
/* istanbul ignore next */
const dataLayerPush = (evtPayload) => {
    const dataLayer = (window.dataLayer = window.dataLayer || []);
    dataLayer.push(evtPayload);
};
exports.dataLayerPush = dataLayerPush;
//# sourceMappingURL=dataLayerPush.js.map